var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "border-r py-2 item-holder",
      staticStyle: { width: "15rem" },
    },
    [
      _c("div", { staticClass: "flex flex-row items-center content-center" }, [
        _c("span", { staticClass: "text ml-3" }, [_vm._v(_vm._s(_vm.name))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }